import { render, staticRenderFns } from "./TransferBar.vue?vue&type=template&id=16979c59&scoped=true"
import script from "./TransferBar.vue?vue&type=script&lang=js"
export * from "./TransferBar.vue?vue&type=script&lang=js"
import style0 from "./TransferBar.vue?vue&type=style&index=0&id=16979c59&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16979c59",
  null
  
)

export default component.exports